const getPromoBriefResponse = (response) => {
  return response?.data?.ecommerces?.map((ecommerce) => {
    return {
      ecommerce: {
        name: ecommerce?.name,
        logo: ecommerce?.logo,
        color: ecommerce?.color,
      },
      items: ecommerce?.promotions?.map((promo) => {
        return {
          ...promo,
          productCountAndPeriod: `${promo?.promotionProducts?.length} Produk | ${promo?.promoPeriod}`,
        };
      }),
    };
  });
};

export default getPromoBriefResponse;
